export const NAME = 'employeeBenefits'

export const EMPLOYEE_BENEFITS_GET = 'employeeBenefitsGet'
export const GET_COBRA_BENEFITS = 'employeeCobraGet'
export const PUT_COBRA_BENEFITS = 'employeeCobraPut'
export const POST_EFFECTIVE_DATES = 'employeeBenefitsEffectivedatesPost'
